import { CONFIG } from "../../config";
import { tw } from "../../styling";
import { icons } from "./icons";

type Props = {
	imageSrc: Icon;
	className?: string;
	height?: number | "auto";
	ariaLabel?: string;
};

export * from "./icons";
export type Icon = keyof typeof icons;

export const SvgIcon = ({ imageSrc, height = 16, className, ariaLabel }: Props) => {
	if (CONFIG.IS_TEST) {
		return <svg id={imageSrc} />;
	}

	const IconComponent = icons[imageSrc];

	return (
		<div
			className={tw("shrink-0", className)}
			aria-hidden={!ariaLabel}
			aria-label={ariaLabel}
			role="img"
		>
			<IconComponent height={height === "auto" ? undefined : height} color="currentColor" />
		</div>
	);
};
